import { Menu } from 'lucide-react'
import React, { Suspense, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  Skeleton,
} from '@/components'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'

import EnvBadge from './env-badge'
import Logo from './logo'

const Navbar = React.lazy(() => import('./navbar'))
const UserArea = React.lazy(() => import('./user-area'))

const NavbarSkeleton = () => (
  <div className="space-y-2">
    <Skeleton className="h-8 bg-zinc-600" />
    <Skeleton className="h-8 bg-zinc-600" />
    <Skeleton className="h-8 bg-zinc-600" />
    <Skeleton className="h-8 bg-zinc-600" />
    <Skeleton className="h-8 bg-zinc-600" />
  </div>
)

export function SidebarMobile() {
  const { user } = useAuthStore()
  const [open, setOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setOpen(false)
  }, [location])

  return (
    <div className="fixed top-0 z-10 w-full select-none bg-zinc-900 px-2">
      <div
        className="flex h-16 items-center gap-2"
        onClick={() => setOpen(true)}
      >
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <Menu className="h-6 w-6 text-white" strokeWidth={2} />
          </SheetTrigger>
          <SheetContent side="left" className="border-none bg-zinc-900">
            <div className="flex h-full flex-col">
              {/* Title */}
              <SheetHeader>
                <SheetTitle className="mb-2 font-light text-lime-200">
                  Menu
                </SheetTitle>
              </SheetHeader>

              {/* Body */}
              {user && (
                <div className="overflow-y-auto text-white">
                  <Suspense fallback={<NavbarSkeleton />}>
                    <Navbar />
                  </Suspense>
                </div>
              )}

              {/* Spacer */}
              <div className="flex-1"></div>

              {/* Footer */}
              <Suspense fallback={<Skeleton className="h-8 bg-zinc-600" />}>
                <UserArea />
              </Suspense>
            </div>
          </SheetContent>
        </Sheet>

        <Logo />
        <div className="flex-1" />
        <EnvBadge />
      </div>
    </div>
  )
}
